module.exports = __webpack_public_path__ + "static/nexusguard-b4356035dc5ae1bb1c598c9cc5a9b191.jpg";